import React, { useEffect, useState } from "react";
import MuiButton from "Components/MuiButton/MuiButton";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Translator from "Languages/Utility/Translator";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import { read } from "Helpers/LocalStorage";
import {
  getAllCountrybySid,
  getAllSeriesByCountry,
  getSelectColor,
  getType,
} from "Stores/actions";
import {
  toggleNAluminiumUpvc,
  toggleNLolayiKeshoyi,
} from "Constants/Constants";
import SeriesProfileTable from "./components/SeriesProfileTable";
import MuiSkeleton from "Components/MuiSkeleton/MuiSkeleton";
import ProfileService from "Services/http/endpoints/properties/ProfileService";
import Input from "Components/Input/Input";
import { DialogActions } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import InsertNewDasteProfile from "./components/InsertNewDasteProfile";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";
import * as Icons from "react-bootstrap-icons";

function ArchiveDasteProfile() {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const { profileTblData } = useSelector((state) => ({
    profileTblData: state.profile.profileTblData,
  }));
  const dispatch = useDispatch();
  const [selectedRow, setSelectedRow] = useState(null);
  const [sizePerPage, setSizePerPage] = useState(5);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [tblData, setTblData] = useState(profileTblData);
  const [controls, setControls] = useSetState({
    country: {
      type: "select",
      selectItems: [],
      value: null,
      validation: null,
      col: {
        sm: 4,
        xs: 12,
      },
    },
    nameBrand: {
      type: "select",
      selectItems: [],
      value: null,
      validation: null,
      col: {
        sm: 4,
        xs: 12,
      },
    },
    nameSearch: {
      type: "search",
      value: null,
      validation: null,
      col: {
        sm: 4,
        xs: 12,
      },
    },
    selectType: {
      type: "toggle",
      arrayItems: toggleNLolayiKeshoyi,
      value: toggleNLolayiKeshoyi[0],
      col: {
        sm: 6,
        xs: 12,
      },
    },
    struct: {
      type: "toggle",
      arrayItems: toggleNAluminiumUpvc,
      value: toggleNAluminiumUpvc[0],
      validation: {
        required: true,
      },
      col: {
        sm: 6,
        xs: 12,
      },
    },
  });

  const handleDialog = () => setOpenDialog(!openDialog);

  const autoCompleteHandler = async (e, value, reason) => {
    setLoading2(true);
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
    if (reason === "select-option" && controlName === "nameBrand") {
      try {
        await onGetAllSeriesByCountry(value.value);
      } catch (err) {
      console.error('[catch error]', err)
    }
    }
    if (reason === "select-option" && controlName === "country") {
      try {
        const params = {
          KeyUser: read("userKey"),
          KeyGroup: read("groupKey"),
          IdCountry: value.value,
        };
        const response = await ProfileService.getAllBrandByCountry(params);
        let brandOptions = response.data.Value;
        brandOptions = brandOptions.map((m) => {
          return {
            ...m,
            value: m.Id,
            label: m.Name,
          };
        });
        brandOptions.unshift({
          value: null,
          label: t("all"),
        });
        setControls({ nameBrand: { selectItems: brandOptions } });
        setControls({ nameBrand: { value: brandOptions[0] } });
        setControls({ nameSearch: { value: "" } });

        await onGetAllSeriesByCountry(
          null,
          controls.selectType.value.value === "lolayi" ? 1 : 2,
          controls.struct.value.value === "upvc" ? 1 : 2,
          value.value,
          1,
          ""
        );
      } catch (err) {
      console.error('[catch error]', err)
    }
    }
    setLoading2(false);
  };

  const onChangeToggle = async (name, key, value) => {
    setControls({ [name]: { value: value } });
    if (name === "selectType") {
      try {
        await onGetAllSeriesByCountry(
          controls.nameBrand.value.value,
          value.value === "lolayi" ? 1 : 2,
          controls.struct.value.value === "upvc" ? 1 : 2,
          controls.country.value ? controls.country.value.value : "1",
          1
        );
      } catch (err) {
      console.error('[catch error]', err)
    }
    }
    if (name === "struct") {
      try {
        await onGetAllSeriesByCountry(
          controls.nameBrand.value.value,
          controls.selectType.value.value === "lolayi" ? 1 : 2,
          value.value === "upvc" ? 1 : 2,
          controls.country.value ? controls.country.value.value : "1",
          1
        );
        const params = {
          KeyUser: read("userKey"),
          KeyGroup: read("groupKey"),
          IdStruct: value.value === "upvc" ? 1 : 2,
        };
        const response = await dispatch(getType(params));
        const paramsColor = {
          KeyUser: read("userKey"),
          KeyGroup: read("groupKey"),
          IdTypeColor: response,
        };
        await dispatch(getSelectColor(paramsColor));
      } catch (err) {
      console.error('[catch error]', err)
    }
    }
  };

  const onEnter = async () => {
    onClear();
    try {
      setLoading(true);
      const paramsCountry = {
        KeyUser: read("userKey"),
        KeyGroup: read("groupKey"),
        IdSCountry: 1,
      };
      const res = await dispatch(getAllCountrybySid(paramsCountry));
      const selectItems = res.map((child) => {
        return {
          label: child.title,
          ...child,
        };
      });
      setControls({ country: { selectItems } });
      setControls({ country: { value: selectItems[0] } });
      await onGetAllSeriesByCountry(null, 1, 1, res[0].value, 1);
      const brandParams = {
        KeyUser: read("userKey"),
        KeyGroup: read("groupKey"),
        IdCountry: res[0].value,
      };
      const responseBrand = await ProfileService.getAllBrandByCountry(
        brandParams
      );
      let brandOptions = responseBrand.data.Value;
      brandOptions = brandOptions.map((m) => {
        return {
          ...m,
          value: m.Id,
          label: m.Name,
        };
      });
      brandOptions.unshift({
        value: null,
        label: t("all"),
      });
      await getTypeColorData();
      setControls({ nameBrand: { selectItems: brandOptions } });
      setControls({ nameBrand: { value: brandOptions[0] } });
      setLoading(false);
    } catch (err) {
      console.error('[catch error]', err)
    }
  };

  const getTypeColorData = async () => {
    setControls({ typesList: { value: "" } });
    setControls({ colorList: { value: "" } });
    const params = {
      KeyUser: read("userKey"),
      KeyGroup: read("groupKey"),
      IdStruct: 1,
    };
    const response = await dispatch(getType(params));
    const paramsColor = {
      KeyUser: read("userKey"),
      KeyGroup: read("groupKey"),
      IdTypeColor: response,
    };
    await dispatch(getSelectColor(paramsColor));
  };

  const onSelectRow = (row) => {
    setSelectedRow(row);
  };

  const setValue = (name, value) => {
    setControls({ [name]: { value: value } });
  };

  const onSearch = async (e) => {
    e.preventDefault();
    await onGetAllSeriesByCountry(
      controls.nameBrand.value.value,
      controls.selectType.value.value === "lolayi" ? 1 : 2,
      controls.struct.value.value === "upvc" ? 1 : 2,
      controls.country.value ? controls.country.value.value : "1",
      1
    );
  };

  const onClearSearch = async (e) => {
    e.preventDefault();
    setControls({ nameSearch: { value: "" } });
    await onGetAllSeriesByCountry(
      controls.nameBrand.value.value,
      controls.selectType.value.value === "lolayi" ? 1 : 2,
      controls.struct.value.value === "upvc" ? 1 : 2,
      controls.country.value ? controls.country.value.value : "1",
      1,
      "CLEAR"
    );
  };

  const onClear = () => {
    setControls({ selectType: { value: toggleNLolayiKeshoyi[0] } });
    setControls({ struct: { value: toggleNAluminiumUpvc[0] } });
    setControls({ nameBrand: { value: null } });
    setControls({ country: { value: null } });
    setControls({ nameSearch: { value: null } });
    setSelectedRow(null);
    setLoading2(false);
  };

  const onGetAllSeriesByCountry = async (
    IdBrand = null,
    Idpop = controls.selectType.value.value === "lolayi" ? 1 : 2,
    IdStruct = controls.struct.value.value === "upvc" ? 1 : 2,
    IdCountry = controls.country.value ? controls.country.value.value : "1",
    Page = 1,
    _name = null
  ) => {
    let dataSearch = null;
    if (_name) {
      if (_name !== "CLEAR")
        dataSearch = { Name: convertToEnglishNumber(_name) };
    } else if (controls.nameSearch.value !== "")
      dataSearch = { Name: convertToEnglishNumber(controls.nameSearch.value) };

    setLoading2(true);
    try {
      const params = {
        KeyUser: read("userKey"),
        KeyGroup: read("groupKey"),
        IdBrand,
        Idpop,
        IdStruct,
        Limit: sizePerPage,
        Page,
        IdCountry,
        ...dataSearch,
      };
      setSelectedRow(null);
      await dispatch(getAllSeriesByCountry(params));
    } catch (err) {
      console.error('[catch error]', err)
    }
    setLoading2(false);
  };

  useEffect(() => {
    const _data = profileTblData.map((i) => {
      return { ...i, Id: i.num };
    });
    setTblData(_data);
  }, [profileTblData]);

  return (
    <>
      <MuiButton
        loading={loading}
        color="primary"
        title={<Translator id={"profile_category_archive"} />}
        onClick={handleDialog}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        onEnter={onEnter}
        onKeyDown={(event) => {
          if (event.keyCode === 13) {
            event.stopPropagation();
            return false;
          }
        }}
        fullWidth
        maxWidth={selectedRow ? 'sm' : 'md'}
      >
        <BackDropLoading loading={loading2} />
        <div>
          <div className="dialogHeader">
            <p>{<Translator id={"profile_category_archive"} />}</p>
          </div>
          <DialogContent id="content-dialog-manager">
            {!loading ? (
              <Grid container>
                <Grid container spacing={2}>
                  {!selectedRow &&
                    Object.keys(controls)
                      .filter(
                        (key) =>
                          controls[key].type === "select" ||
                          controls[key].type === "search"
                      )
                      .map((key, index) => {
                        return (
                          <Grid
                            item
                            sm={controls[key].col.sm}
                            xs={controls[key].col.xs}
                            key={key + index}
                            style={{marginTop: controls[key].type === "search" ? '18px' : '0px'}}
                          >
                            {controls[key].type === "select" && (
                              <MuiAutoComplete
                                autoSelect={true}
                                loading={loading}
                                options={controls[key].selectItems}
                                label={<Translator id={key} />}
                                value={controls[key].value}
                                id={key}
                                onChange={autoCompleteHandler}
                              />
                            )}
                            {controls[key].type === "search" && (
                              <Input
                                placeholder={t("nameSearch")}
                                setValue={setValue.bind(this)}
                                name={key}
                                value={
                                  controls[key].value ? controls[key].value : ""
                                }
                                type="search"
                                onSearch={onSearch}
                                onClearSearch={onClearSearch}
                              />
                            )}
                          </Grid>
                        );
                      })}
                </Grid>
                <Grid container spacing={2} className="my-2">
                  {!selectedRow &&
                    Object.keys(controls)
                      .filter((key) => controls[key].type === "toggle")
                      .map((key, index) => {
                        return (
                          <Grid
                            item
                            md={controls[key].col.md}
                            sm={controls[key].col.sm}
                            xs={controls[key].col.xs}
                            key={key + index}
                          >
                            <MuiRadioGroup
                              name={key}
                              label={<Translator id={key} />}
                              value={controls[key].value}
                              items={controls[key].arrayItems}
                              onChange={onChangeToggle}
                              translate={true}
                              className="horizontalRadio"
                            />
                          </Grid>
                        );
                      })}
                </Grid>
                {!loading && !selectedRow && (
                  <Grid
                    item
                    xs={12}
                    className="alert alert-warning text-center mb-2 rounded"
                  >
                    <Translator id={"clickToAddProfile"} noSpan />
                  </Grid>
                )}
                <Grid item xs={12}>
                  {tblData && !selectedRow && (
                    <SeriesProfileTable
                      data={tblData}
                      onSelect={onSelectRow}
                      selected={selectedRow ? [selectedRow.num] : []}
                      idpop={
                        controls.selectType.value.value === "lolayi" ? 1 : 2
                      }
                      idStruct={controls.struct.value.value === "upvc" ? 1 : 2}
                      idCountry={
                        controls.country.value
                          ? controls.country.value.value
                          : "1"
                      }
                      idBrand={controls.nameBrand.value}
                      nameSearch={controls.nameSearch.value}
                      limit={sizePerPage}
                    />
                  )}
                </Grid>
                {!loading && selectedRow && (
                  <InsertNewDasteProfile
                    selectedRow={selectedRow}
                    onLoad={(val) => setLoading2(val)}
                    onDone={handleDialog}
                  />
                )}
              </Grid>
            ) : (
              <MuiSkeleton xs={4} number={12} />
            )}
          </DialogContent>
          <DialogActions>
            {!loading && selectedRow && (
              <MuiButton
                color="secondary"
                title={<Translator id="backToList" />}
                innerIcon={<Icons.ListUl />}
                onClick={() => {
                  setSelectedRow(null);
                }}
                fullwidthOnSm
              />
            )}

            <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </div>
      </Dialog>
    </>
  );
}

export default ArchiveDasteProfile;
